import instance, { ADMIN_PREFIX } from 'services/api';
import {
  PermissionRow,
  RoleDetail,
  RoleInput,
  RoleListRow
} from 'types/api/roles';

/** GET /api/v2/admin/roles/groups — top-level parent roles. */
export const fetchRolesGroup = async (): Promise<RoleListRow[]> => {
  const res = await instance.get<RoleListRow[]>(`${ADMIN_PREFIX}/roles/groups`);

  return res.data ?? [];
};

/** GET /api/v2/admin/roles/parent/:parent_id — children of a parent role. */
export const fetchRolesByParent = async (
  parentId: string | number
): Promise<RoleListRow[]> => {
  const res = await instance.get<RoleListRow[]>(
    `${ADMIN_PREFIX}/roles/parent/${parentId}`
  );

  return res.data ?? [];
};

/** GET /api/v2/admin/roles/:id — role detail with role_permissions hydrated. */
export const fetchRoleById = async (
  id: string | number
): Promise<RoleDetail> => {
  const res = await instance.get<RoleDetail>(`${ADMIN_PREFIX}/roles/${id}`);

  return res.data;
};

/**
 * GET /api/v2/admin/roles/permissions/:roleName — catalog Permission[]
 * with PermissionValue[] hydrated as `values`. Cycle-18 reshape.
 */
export const fetchPermissionsByRoleName = async (
  roleName: string
): Promise<PermissionRow[]> => {
  const res = await instance.get<{ data?: PermissionRow[] } | PermissionRow[]>(
    `${ADMIN_PREFIX}/roles/permissions/${roleName}`
  );

  // BE returns the array directly (per cycle-18 closure note); some legacy
  // tooling expects a {data: …} envelope, so accept both.
  if (Array.isArray(res.data)) return res.data;

  return (res.data?.data as PermissionRow[]) ?? [];
};

export const createRole = (input: RoleInput) =>
  instance.post<RoleDetail>(`${ADMIN_PREFIX}/roles`, input);

export const updateRole = (id: string | number, input: RoleInput) =>
  instance.put<RoleDetail>(`${ADMIN_PREFIX}/roles/${id}`, input);

export const deleteRole = (id: string | number) =>
  instance.delete<{ status: boolean }>(`${ADMIN_PREFIX}/roles/${id}`);
